import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  MenuItem,
  Select,
  FormControl,
  Card,
  CardContent,
  useMediaQuery,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  Autocomplete,
  TextField,
  DialogActions,
} from "@mui/material";
import { CheckCircle as CheckCircleIcon } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
import { ChevronLeft, ChevronRight, ExpandMore } from "@mui/icons-material";
import DocumentPreview from "../components/Documents";
import ExtractedData from "../components/ExtractData";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import EmptyState from "../components/EmptyState";
import { getSilverLoanApplication, getAllApplications, getApplicationDetails, getAadhaarApplication, getAadhaarPdfUrl, updateAadhaarApplication, updateSilverLoanApplication, getPanApplication, getPanPdfUrl, updatePanApplication, getItrApplication, getItrPdfUrl, updateItrApplication, getNetWorth, getNetWorthPdfUrl, updateNetWorth, getCibil, getCibilPdfUrl, updateCibil, getBalanceSheet, getBalanceSheetPdfUrl, updateBalanceSheet, getBankStat, getBankStatPdfUrl, updateBankStat, getBankStatSummary, getBankStatSummaryPdfUrl, updateBankStatSummary, getCompanyCibil, getCompanyCibilPdfUrl, updateCompanyCibil, getGst, getGstPdfUrl, updateGst, getProfitLoss, getProfitLossPdfUrl, updateProfitLoss, getUdyam, getUdyamPdfUrl, updateUdyam, incrementVerification as apiIncrementVerification } from "../api";
import { getSilverPdfUrl, API_BASE } from "../api";

import ThumbIcon from "../icon/thumb.png";
import CheckIcon from "../icon/check.png";
import BusinessIcon from '@mui/icons-material/Business';
import { useNavigate, useParams } from "react-router-dom";
import { logout } from '../services/authService';


const Application = () => {
  const navigate = useNavigate();

  // Handle logout
  const handleLogout = async () => {
    console.log(' [APPLICATION] Logout initiated from sidebar');
    try {
      await logout('manual');
      // logout function handles redirect
    } catch (error) {
      console.error(' [APPLICATION] Logout error:', error);
      // Force logout even if API fails
      localStorage.clear();
      navigate('/login');
    }
  };
  // State for dynamic data from backend
  const { id } = useParams(); // this will be your application number
  const [applications, setApplications] = useState([]);
  const [selectedApplication, setSelectedApplication] = useState("");
  const [applicationPdfs, setApplicationPdfs] = useState([]);
  const [currentPdfIndex, setCurrentPdfIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [silverDetails, setSilverDetails] = useState(null);
  const [aadhaarPrDetails, setAadhaarPrDetails] = useState(null);
  const [aadhaarCoDetails, setAadhaarCoDetails] = useState(null);
  const [panPrDetails, setPanPrDetails] = useState(null);
  const [panCoDetails, setPanCoDetails] = useState(null);
  const [itrPrDetails, setItrPrDetails] = useState(null);
  const [itrPr2022Details, setItrPr2022Details] = useState(null);
  const [itrCo2022Details, setItrCo2022Details] = useState(null);
  const [itrCo2023Details, setItrCo2023Details] = useState(null);
  const [itrCoDetails, setItrCoDetails] = useState(null);
  const [netWorthDetails, setNetWorthDetails] = useState(null);
  const [cibilDetails, setCibilDetails] = useState(null);
  const [balanceSheetDetails, setBalanceSheetDetails] = useState({ '2022': null, '2023': null, '2024': null });
  const [bankStatDetails, setBankStatDetails] = useState(null);
  const [bankStatSummaryDetails, setBankStatSummaryDetails] = useState(null);
  const [companyCibilDetails, setCompanyCibilDetails] = useState(null);
  const [gstDetails, setGstDetails] = useState(null);
  const [profitLossDetails, setProfitLossDetails] = useState(null);
  const [udyamDetails, setUdyamDetails] = useState(null);
  const [adhardetails, setAdhardetails] = useState(null);
  const [verifiedPages, setVerifiedPages] = useState(new Set());
  const [verificationCount, setVerificationCount] = useState('0/21');
  const [isPageVerified, setIsPageVerified] = useState(false);
  const [totalFiles, setTotalFiles] = useState(21);
  const [currentDocumentType, setCurrentDocumentType] = useState('');
  const [currentRole, setCurrentRole] = useState('');
  // UI State
  const [collapsed, setCollapsed] = useState(true);
  const [openPopup, setOpenPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("");
  const [verifiedApplications, setVerifiedApplications] = useState(() => {
    // Load from sessionStorage to persist across page reloads
    try {
      const stored = sessionStorage.getItem('VERIFIED_APPLICATIONS');
      return stored ? new Set(JSON.parse(stored)) : new Set();
    } catch (_) {
      return new Set();
    }
  }); // Track verified apps

  // Responsive breakpoints
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  // Backend API base URL
  // const API_BASE = "http://localhost:5000"; // Commented out: using static data

  // Placeholder business meta to display in stat-style cards (replace when backend provides)
  const businessName = "Raksha Solar House";
  const constitution = "Borrower Name";

  // ========================
  // Helper Functions
  // ========================
  // ========================
  // Helper Functions
  // ========================

  // Helper function to get correct API endpoint based on page type
  const getUpdateEndpoint = (pageType) => {
    const endpoints = {
      'silver': '/silver/loanapplications',
      'aadhaar_pr': '/silver/adharapplications',
      'aadhaar_co': '/silver/adharapplications',
      'pan_pr': '/silver/panapplications',
      'pan_co': '/silver/panapplications',
      'itr_pr_2022': '/silver/itrapplications',
      'itr_pr': '/silver/itrapplications',
      'itr_co_2022': '/silver/itrapplications',
      'itr_co_2023': '/silver/itrapplications',
      'itr_co': '/silver/itrapplications',
      'networth_pr': '/silver/networth',
      'networth_co': '/silver/networth',
      'cibil_pr': '/silver/cibil',
      'cibil_co': '/silver/cibil',
      'balancesheet_2022': '/silver/balancesheet',
      'balancesheet_2023': '/silver/balancesheet',
      'balancesheet_2024': '/silver/balancesheet',
      'bankstat': '/silver/bankstat',
      'bankstat_summary': '/silver/bankstat-summary',
      'company_cibil': '/silver/company-cibil',
      'gst': '/silver/gst',
      'profit_loss_2022': '/silver/profit-loss',
      'profit_loss_2023': '/silver/profit-loss',
      'profit_loss_2024': '/silver/profit-loss',
      'udyam': '/silver/udyam'
    };

    return endpoints[pageType] || '/silver/loanapplications';
  };

  // Helper to get query params for the endpoint
  const getQueryParams = (pageType) => {
    const params = {};

    // Add role for role-based documents
    if (pageType.includes('_pr')) params.role = 'PR';
    if (pageType.includes('_co')) params.role = 'CO1';

    // Add year for year-based documents
    if (pageType.includes('_2022')) params.year = '2022';
    if (pageType.includes('_2023')) params.year = '2023';
    if (pageType.includes('_2024')) params.year = '2024';

    return params;
  };

  // Get the current set of verified pages
  const getVerifiedPages = () => {
    return verifiedPages;
  };
  // ========================
  // API Functions
  // ========================

  // Load and sync verification status from server and sessionStorage
  useEffect(() => {
    if (!id) return;

    const loadVerification = async () => {
      try {
        // 1. First try to get from server (use Gold endpoint for complete data)
        const response = await getApplicationDetails(id).catch(() => ({}));
        const serverData = response?.data || response || {};
        const serverVerification = serverData.verification || '0/21';

        console.log('Loading verification from server:', serverVerification);

        // Parse the count and total
        const [verifiedCount, totalCount] = serverVerification.split('/').map(Number);
        const totalFiles = totalCount || 21;

        console.log(`Setting verification count to: ${verifiedCount}/${totalFiles}`);

        // Update state
        setTotalFiles(totalFiles);
        setVerificationCount(`${verifiedCount}/${totalFiles}`);

        // Update verified pages
        const verifiedSet = new Set();
        if (verifiedCount > 0) {
          for (let i = 0; i < verifiedCount; i++) {
            verifiedSet.add(`page_${i + 1}`);
          }
        }

        setVerifiedPages(verifiedSet);

        // Save to sessionStorage
        sessionStorage.setItem(`verification_${id}`, `${verifiedCount}/${totalFiles}`);
        sessionStorage.setItem(`verifiedPages_${id}`, JSON.stringify(Array.from(verifiedSet)));

      } catch (error) {
        console.error('Error loading verification:', error);
        // Fall back to sessionStorage on error
        const savedVerification = sessionStorage.getItem(`verification_${id}`) || '0/21';
        console.log('Falling back to saved verification:', savedVerification);
        setVerificationCount(savedVerification);

        const savedPages = sessionStorage.getItem(`verifiedPages_${id}`);
        if (savedPages) {
          setVerifiedPages(new Set(JSON.parse(savedPages)));
        }
      }
    };

    loadVerification();
  }, [id]);

  // Update verification status when verified pages or current page changes
  useEffect(() => {
    if (applicationPdfs.length > 0 && currentPdfIndex >= 0) {
      const currentPageId = applicationPdfs[currentPdfIndex]?.id;
      setIsPageVerified(verifiedPages.has(currentPageId));
    }
  }, [currentPdfIndex, applicationPdfs, verifiedPages]);

  // Handle verification of current page

  const handlePageVerification = async () => {
    try {
      if (!selectedApplication) {
        console.warn(' [VERIFY] Missing selectedApplication');
        return { success: false, error: 'Missing application' };
      }

      const pageNumber = currentPdfIndex + 1;
      const pageId = `${currentDocumentType}_${currentRole}_page_${pageNumber}`;

      console.log(` [VERIFY] Attempting verification:`, {
        pageId,
        documentType: currentDocumentType,
        role: currentRole,
        pageNumber
      });

      const response = await fetch(
        `${API_BASE}/applications/${selectedApplication}/verification/increment`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ pageId })
        }
      );

      const result = await response.json();
      console.log(' [VERIFY] Backend response:', result);

      if (result.success) {
        setVerificationCount(result.display);

        //  Mark page as verified locally
        setVerifiedPages(prev => new Set([...prev, pageId]));
        setIsPageVerified(true);

        //  UPDATE: Also update the rightPanelData to reflect verification
        // This will trigger DocumentPreview to show the icon immediately
        updateCurrentPageVerification();

        sessionStorage.setItem(`verification_${selectedApplication}`, result.display);

        // if (result.isNewVerification) {
        //   showPopup(` Page verified! Progress: ${result.display}`, "success");
        // } else {
        //   console.log(` Page already verified. Progress: ${result.display}`);
        // }
      }

      return result;
    } catch (error) {
      console.error(' [VERIFY] Request failed:', error);
      showPopup("Failed to verify page. Please try again.", "error");
      return { success: false, error: error.message };
    }
  };

  //  NEW FUNCTION: Update verification status for current page data
  const updateCurrentPageVerification = () => {
    // Update the appropriate details state based on current page type
    if (currentPageType === 'aadhaar_pr') {
      setAadhaarPrDetails(prev => ({ ...prev, verificationId: 1 }));
    } else if (currentPageType === 'aadhaar_co') {
      setAadhaarCoDetails(prev => ({ ...prev, verificationId: 1 }));
    } else if (currentPageType === 'pan_pr') {
      setPanPrDetails(prev => ({ ...prev, verificationId: 1 }));
    } else if (currentPageType === 'pan_co') {
      setPanCoDetails(prev => ({ ...prev, verificationId: 1 }));
    } else if (currentPageType === 'itr_pr_2022') {
      setItrPr2022Details(prev => ({ ...prev, verificationId: 1 }));
    } else if (currentPageType === 'itr_pr') {
      setItrPrDetails(prev => ({ ...prev, verificationId: 1 }));
    } else if (currentPageType === 'itr_co_2022') {
      setItrCo2022Details(prev => ({ ...prev, verificationId: 1 }));
    } else if (currentPageType === 'itr_co_2023') {
      setItrCo2023Details(prev => ({ ...prev, verificationId: 1 }));
    } else if (currentPageType === 'itr_co') {
      setItrCoDetails(prev => ({ ...prev, verificationId: 1 }));
    } else if (currentPageType === 'networth_pr') {
      setNetWorthDetails(prev => ({
        ...prev,
        pr: { ...(prev?.pr || {}), verificationId: 1 }
      }));
    } else if (currentPageType === 'networth_co') {
      setNetWorthDetails(prev => ({
        ...prev,
        co: { ...(prev?.co || {}), verificationId: 1 }
      }));
    } else if (currentPageType === 'cibil_pr') {
      setCibilDetails(prev => ({
        ...prev,
        pr: { ...(prev?.pr || {}), verificationId: 1 }
      }));
    } else if (currentPageType === 'cibil_co') {
      setCibilDetails(prev => ({
        ...prev,
        co: { ...(prev?.co || {}), verificationId: 1 }
      }));
    } else if (currentPageType === 'balancesheet_2022') {
      setBalanceSheetDetails(prev => ({
        ...prev,
        '2022': { ...(prev?.['2022'] || {}), verificationId: 1 }
      }));
    } else if (currentPageType === 'balancesheet_2023') {
      setBalanceSheetDetails(prev => ({
        ...prev,
        '2023': { ...(prev?.['2023'] || {}), verificationId: 1 }
      }));
    } else if (currentPageType === 'balancesheet_2024') {
      setBalanceSheetDetails(prev => ({
        ...prev,
        '2024': { ...(prev?.['2024'] || {}), verificationId: 1 }
      }));
   } else if (currentPageType === 'company_cibil') {
      setCompanyCibilDetails(prev => prev ? { ...prev, verificationId: 1 } : prev);
   } else if (currentPageType === 'gst') {
      setGstDetails(prev => prev ? { ...prev, verificationId: 1 } : prev);
    } else if (currentPageType === 'profit_loss_2022') {
      setProfitLossDetails(prev => ({
        ...prev,
        '2022': { ...(prev?.['2022'] || {}), verificationId: 1 }
      }));
    } else if (currentPageType === 'profit_loss_2023') {
      setProfitLossDetails(prev => ({
        ...prev,
        '2023': { ...(prev?.['2023'] || {}), verificationId: 1 }
      }));
    } else if (currentPageType === 'profit_loss_2024') {
      setProfitLossDetails(prev => ({
        ...prev,
        '2024': { ...(prev?.['2024'] || {}), verificationId: 1 }
      }));
    } else if (currentPageType === 'udyam') {
      setUdyamDetails(prev => ({ ...prev, verificationId: 1 }));
    } else if (currentPageType === 'silver') {
      setSilverDetails(prev => ({ ...prev, verificationId: 1 }));
    }
  };

  // Fetch all application numbers from backend (same as Summary)
  const fetchApplications = async () => {
    try {
      const res = await getAllApplications({ page: 1, limit: 50 });
      const list = Array.isArray(res?.applications)
        ? res.applications.map((a) => a.applicationNo).filter(Boolean)
        : [];

      const normalizedId = id ? String(id).toUpperCase() : null;
      const options = normalizedId && !list.includes(normalizedId)
        ? [normalizedId, ...list]
        : list;

      setApplications(options);

      const initial = normalizedId || options[0] || '';
      setSelectedApplication(initial);
      if (initial) fetchApplicationPdfs(initial);
    } catch (e) {
      console.error('Failed to load applications:', e?.message || e);
      setApplications([]);
    }
  };

  // Fetch details from Gold (for scores, memo, etc.) and Silver (for PDFs) and build left PDF + right fields
  const fetchApplicationPdfs = async (applicationNumber) => {
    if (!applicationNumber) return;
    try {
      setLoading(true);

      // Fetch Gold application details (has scores, memo number, etc.)
      const goldRes = await getApplicationDetails(applicationNumber).catch(() => ({}));
      const goldData = goldRes?.data || goldRes || {};

      // Fetch Silver details (has PDF paths and loan application fields)
      const silverRes = await getSilverLoanApplication(applicationNumber).catch(() => ({}));
      const silver = silverRes?.data || silverRes || {};
      const silverConfidenceScores = silverRes?.confidenceScores || {};

      // Combine the data - use Silver for loan application fields, Gold for scores/memo
      const combinedData = {
        ...silver, // Include all silver fields (loan application data)
        ...goldData, // Override with gold data (scores, memo)
        pdfPath: silver.pdfPath || goldData.pdfPath,
        jsonPath: silver.jsonPath || goldData.jsonPath,
        // Ensure we have the scores and memo from Gold data
        scores: goldData.scores || {
          application: { display: 'N/A' },
          financial: { display: 'N/A' },
          bureau: { display: 'N/A' },
          overall: { display: 'N/A' }
        },
        memoNo: goldData.memoNo || 'N/A',
        registrationDate: goldData.registrationDate || 'N/A',
        confidenceScores: silverConfidenceScores // Add confidence scores to combined data
      };

      // Get verification from response or use default
      const verificationValue = silver.verification || '4/21'; // Set default to 4/21 based on logs
      console.log('Server verification value:', verificationValue);

      // Parse verification value (e.g., '4/21' -> 4 verified)
      const [verified, total] = verificationValue.split('/').map(Number);
      const totalFiles = total || 21; // Use the total from server or fallback to 21

      console.log(`Parsed verification: ${verified} out of ${totalFiles}`);

      // Update state
      setTotalFiles(totalFiles);

      // Create verified pages set
      const verifiedSet = new Set();
      if (verified > 0) {
        for (let i = 0; i < verified; i++) {
          verifiedSet.add(`page_${i + 1}`);
        }
      }

      // Update state and storage
      setVerifiedPages(verifiedSet);

      // Set the verification count using the values from server
      const newVerificationCount = `${verified}/${totalFiles}`;
      setVerificationCount(newVerificationCount);

      // Save to sessionStorage
      sessionStorage.setItem(`verifiedPages_${id}`, JSON.stringify(Array.from(verifiedSet)));
      sessionStorage.setItem(`verification_${id}`, newVerificationCount);

      console.log('Updated verification count to:', newVerificationCount);

      console.log('Updated verification state:', {
        count: verificationValue,
        verifiedPages: Array.from(verifiedSet)
      });

      const silverRawPath = (combinedData?.pdfPath || '').toString();
      const silverPreviewUrl = silverRawPath ? getSilverPdfUrl(applicationNumber) : null;

      console.log('🎯 [SILVER DATA] Combined data with confidence scores:', {
        hasConfidenceScores: !!combinedData.confidenceScores,
        confidenceScoresCount: combinedData.confidenceScores ? Object.keys(combinedData.confidenceScores).length : 0,
        confidenceScores: combinedData.confidenceScores
      });

      setSilverDetails(combinedData); // Use combined data instead of just silver
      // Fetch Aadhaar PR details (default) and probe Co-Applicant for PDF presence
      const aadhaarPrRes = await getAadhaarApplication(applicationNumber, { role: 'PR' }).catch(() => ({}));
      const aadhaarPr = aadhaarPrRes?.data || null;
      const aadhaarPrRawPathAny = (aadhaarPr?.pdfPath || aadhaarPr?.PdfPath || '').toString();
      const aadhaarPrPreviewUrl = aadhaarPrRawPathAny ? getAadhaarPdfUrl(applicationNumber, 'PR') : null;
      setAadhaarPrDetails(aadhaarPr);

      // Probe Co-Applicant only for preview (strict role = CO1)
      const aadhaarCoRes = await getAadhaarApplication(applicationNumber, { role: 'CO1' }).catch(() => ({}));
      const aadhaarCo = aadhaarCoRes?.data || null;
      const aadhaarCoRawPathAny = (aadhaarCo?.pdfPath || aadhaarCo?.PdfPath || '').toString();
      const aadhaarCoPreviewUrl = aadhaarCoRawPathAny ? getAadhaarPdfUrl(applicationNumber, 'CO1') : null;

      // Fetch PAN PR details and probe CO1 for preview
      const panPrRes = await getPanApplication(applicationNumber, { role: 'PR' }).catch(() => ({}));
      const panPr = panPrRes?.data || null;
      const panPrRawPath = (panPr?.pdfPath || panPr?.PdfPath || '').toString();
      const panPrPreviewUrl = panPrRawPath ? getPanPdfUrl(applicationNumber, 'PR') : null;
      setPanPrDetails(panPr);

      const panCoRes = await getPanApplication(applicationNumber, { role: 'CO1' }).catch(() => ({}));
      const panCo = panCoRes?.data || null;
      const panCoRawPath = (panCo?.pdfPath || panCo?.PdfPath || '').toString();
      const panCoPreviewUrl = panCoRawPath ? getPanPdfUrl(applicationNumber, 'CO1') : null;
      setPanCoDetails(panCo);

      // Fetch ITR PR (AY=2022) and PR (latest), plus CO1 details
      const itrPr2022Res = await getItrApplication(applicationNumber, { role: 'PR', year: '2022' }).catch(() => ({}));
      const itrPr2022 = itrPr2022Res?.data || null;
      const itrPr2022RawPath = (itrPr2022?.pdfPath || itrPr2022?.PdfPath || '').toString();
      const itrPr2022PreviewUrl = itrPr2022RawPath ? getItrPdfUrl(applicationNumber, 'PR', '2022') : null;
      setItrPr2022Details(itrPr2022);

      const itrPrRes = await getItrApplication(applicationNumber, { role: 'PR', year: '2023' }).catch(() => ({}));
      const itrPr = itrPrRes?.data || null;
      const itrPrRawPath = (itrPr?.pdfPath || itrPr?.PdfPath || '').toString();
      const itrPrPreviewUrl = itrPrRawPath ? getItrPdfUrl(applicationNumber, 'PR') : null;
      setItrPrDetails(itrPr);

      // CO1 ITR year-specific and latest
      const [itrCo2022Res, itrCo2023Res, itrCoRes] = await Promise.all([
        getItrApplication(applicationNumber, { role: 'CO1', year: '2022' }).catch(() => ({})),
        getItrApplication(applicationNumber, { role: 'CO1', year: '2023' }).catch(() => ({})),
        getItrApplication(applicationNumber, { role: 'CO1', year: '2024' }).catch(() => ({}))
      ]);
      const itrCo2022 = itrCo2022Res?.data || null;
      const itrCo2023 = itrCo2023Res?.data || null;
      const itrCo = itrCoRes?.data || null;

      const itrCo2022RawPath = (itrCo2022?.pdfPath || itrCo2022?.PdfPath || '').toString();
      const itrCo2022PreviewUrl = itrCo2022RawPath ? getItrPdfUrl(applicationNumber, 'CO1', '2022') : null;

      const itrCo2023RawPath = (itrCo2023?.pdfPath || itrCo2023?.PdfPath || '').toString();
      const itrCo2023PreviewUrl = itrCo2023RawPath ? getItrPdfUrl(applicationNumber, 'CO1', '2023') : null;

      const itrCoRawPath = (itrCo?.pdfPath || itrCo?.PdfPath || '').toString();
      const itrCoPreviewUrl = itrCoRawPath ? getItrPdfUrl(applicationNumber, 'CO1') : null;

      setItrCo2022Details(itrCo2022);
      setItrCo2023Details(itrCo2023);
      setItrCoDetails(itrCo);

      // Fetch Net Worth PR and CO1 details
      const nwPrRes = await getNetWorth(applicationNumber, { role: 'PR' }).catch(() => ({}));
      const nwPr = nwPrRes?.data || null;
      const nwPrRawPath = (nwPr?.pdfPath || nwPr?.PdfPath || '').toString();
      const nwPrPreviewUrl = getNetWorthPdfUrl(applicationNumber, 'PR');

      const nwCoRes = await getNetWorth(applicationNumber, { role: 'CO1' }).catch(() => ({}));
      const nwCo = nwCoRes?.data || null;
      const nwCoPreviewUrl = getNetWorthPdfUrl(applicationNumber, 'CO1');

      setNetWorthDetails({ pr: nwPr || null, co: nwCo || null });

      // Fetch CIBIL PR and CO1 details
      const cbPrRes = await getCibil(applicationNumber, { role: 'PR' }).catch(() => ({}));
      const cibilPr = cbPrRes?.data || null;
      const cibilPrPreviewUrl = getCibilPdfUrl(applicationNumber, 'PR');

      const cbCoRes = await getCibil(applicationNumber, { role: 'CO1' }).catch(() => ({}));
      const cibilCo = cbCoRes?.data || null;
      const cibilCoPreviewUrl = getCibilPdfUrl(applicationNumber, 'CO1');

      setCibilDetails({ pr: cibilPr || null, co: cibilCo || null });

      // Fetch Balance Sheet details by Assessment_Year
      const [bs2022Res, bs2023Res, bs2024Res] = await Promise.all([
        getBalanceSheet(applicationNumber, { year: '2022' }).catch(() => ({})),
        getBalanceSheet(applicationNumber, { year: '2023' }).catch(() => ({})),
        getBalanceSheet(applicationNumber, { year: '2024' }).catch(() => ({})),
      ]);
      const bs2022 = bs2022Res?.data || null;
      const bs2023 = bs2023Res?.data || null;
      const bs2024 = bs2024Res?.data || null;
      const bs2022Raw = (bs2022?.pdfPath || bs2022?.PdfPath || '').toString();
      const bs2023Raw = (bs2023?.pdfPath || bs2023?.PdfPath || '').toString();
      const bs2024Raw = (bs2024?.pdfPath || bs2024?.PdfPath || '').toString();
      const bs2022PreviewUrl = bs2022Raw ? getBalanceSheetPdfUrl(applicationNumber, '2022') : null;
      const bs2023PreviewUrl = bs2023Raw ? getBalanceSheetPdfUrl(applicationNumber, '2023') : null;
      const bs2024PreviewUrl = bs2024Raw ? getBalanceSheetPdfUrl(applicationNumber, '2024') : null;
      setBalanceSheetDetails({ '2022': bs2022, '2023': bs2023, '2024': bs2024 });

      // Fetch Bank Stat details (latest row) and preview URL
      const bankStatRes = await getBankStat(applicationNumber).catch(() => ({}));
      const bankStat = bankStatRes?.data || null;
      // Always point to backend PDF endpoint; backend will derive from JsonPath if PdfPath is missing
      const bankStatPreviewUrl = getBankStatPdfUrl(applicationNumber);
      setBankStatDetails(bankStat);

      // Fetch Bank Stat Summary (latest row)
      const bssRes = await getBankStatSummary(applicationNumber).catch(() => ({}));
      const bankStatSummary = bssRes?.data || null;
      const bankStatSummaryPreviewUrl = getBankStatSummaryPdfUrl(applicationNumber);
      setBankStatSummaryDetails(bankStatSummary);

      // Fetch Company CIBIL
      const compCibilRes = await getCompanyCibil(applicationNumber).catch(() => ({}));
      const compCibil = compCibilRes?.data || null;
      const compCibilPreviewUrl = getCompanyCibilPdfUrl(applicationNumber);
      setCompanyCibilDetails(compCibil);

      // GST (latest row)
      const gstRes = await getGst(applicationNumber).catch(() => ({}));
      const gst = gstRes?.data || null;
      const gstPreviewUrl = getGstPdfUrl(applicationNumber);
      setGstDetails(gst);

      // Profit & Loss per Assessment_Year
      const pl2022Res = await getProfitLoss(applicationNumber, { year: '2022' }).catch(() => ({}));
      const pl2023Res = await getProfitLoss(applicationNumber, { year: '2023' }).catch(() => ({}));
      const pl2024Res = await getProfitLoss(applicationNumber, { year: '2024' }).catch(() => ({}));
      const pl2022 = pl2022Res?.data || null;
      const pl2023 = pl2023Res?.data || null;
      const pl2024 = pl2024Res?.data || null;
      const pl2022PreviewUrl = getProfitLossPdfUrl(applicationNumber, { year: '2022' });
      const pl2023PreviewUrl = getProfitLossPdfUrl(applicationNumber, { year: '2023' });
      const pl2024PreviewUrl = getProfitLossPdfUrl(applicationNumber, { year: '2024' });
      setProfitLossDetails({ '2022': pl2022, '2023': pl2023, '2024': pl2024 });

      // UDYAM certificate
      const udyamRes = await getUdyam(applicationNumber).catch(() => ({}));
      const udyam = udyamRes?.data || null;
      const udyamPreviewUrl = getUdyamPdfUrl(applicationNumber);
      setUdyamDetails(udyam);

      // Also store Co-Applicant details snapshot if present
      setAadhaarCoDetails(aadhaarCo);

      // Build fixed pagination in required order
      const makeName = (url, fallback) => {
        try {
          if (!url) return fallback;
          const u = new URL(url);
          const last = decodeURIComponent((u.pathname.split('/').pop()) || '');
          return (last && last.includes('.')) ? last : fallback;
        } catch {
          try {
            const clean = (url || '').split('?')[0];
            const last = decodeURIComponent(clean.substring(clean.lastIndexOf('/') + 1));
            return (last && last.includes('.')) ? last : fallback;
          } catch {
            return fallback;
          }
        }
      };
      const pages = [
        { id: 'silver', url: silverPreviewUrl || "https://deetsxstorage.blob.core.windows.net/deetsx-applications/APP0A1AKA4M/Original_Docs/COM_LOAN_Application.pdf", name: makeName(silverPreviewUrl || "https://deetsxstorage.blob.core.windows.net/deetsx-applications/APP0A1AKA4M/Original_Docs/COM_LOAN_Application.pdf", "Loan Application.pdf") },
        { id: 'aadhaar_pr', url: aadhaarPrPreviewUrl || null, name: makeName(aadhaarPrPreviewUrl, "Primary Applicant – Aadhaar Card.pdf") },
        { id: 'pan_pr', url: panPrPreviewUrl || null, name: makeName(panPrPreviewUrl, "Primary Applicant – PAN Card.pdf") },
        { id: 'itr_pr_2022', url: itrPr2022PreviewUrl || null, name: makeName(itrPr2022PreviewUrl, "Primary Applicant – Income Tax Return (AY 2022–23).pdf") }, // page 4
        { id: 'itr_pr', url: itrPrPreviewUrl || null, name: makeName(itrPrPreviewUrl, "Primary Applicant – Income Tax Return (AY 2023–24).pdf") },           // page 5
        { id: 'networth_pr', url: nwPrPreviewUrl || null, name: makeName(nwPrPreviewUrl, "Primary Applicant – Net Worth Statement.pdf") },
        { id: 'cibil_pr', url: cibilPrPreviewUrl || null, name: makeName(cibilPrPreviewUrl, "Primary Applicant – Credit Report (CIBIL).pdf") },
        { id: 'aadhaar_co', url: aadhaarCoPreviewUrl || null, name: makeName(aadhaarCoPreviewUrl, "Co-Applicant 1 – Aadhaar Card.pdf") },
        { id: 'pan_co', url: panCoPreviewUrl || null, name: makeName(panCoPreviewUrl, "Co-Applicant 1 – PAN Card.pdf") },
        { id: 'itr_co_2022', url: itrCo2022PreviewUrl || null, name: makeName(itrCo2022PreviewUrl, "Co-Applicant 1 – Income Tax Return (AY 2022–23).pdf") },  // page 10
        { id: 'itr_co_2023', url: itrCo2023PreviewUrl || null, name: makeName(itrCo2023PreviewUrl, "Co-Applicant 1 – Income Tax Return (AY 2023–24).pdf") },  // page 11
        // { id: 'networth_co', url: nwCoPreviewUrl || null, name: makeName(nwCoPreviewUrl, "NetWorth_CO1.pdf") },
        { id: 'cibil_co', url: cibilCoPreviewUrl || null, name: makeName(cibilCoPreviewUrl, "	Co-Applicant 1 – Credit Report (CIBIL).pdf") },
        { id: 'balancesheet_2022', url: bs2022PreviewUrl || null, name: makeName(bs2022PreviewUrl, "Company – Balance Sheet (FY 2021–22).pdf") },
        { id: 'balancesheet_2023', url: bs2023PreviewUrl || null, name: makeName(bs2023PreviewUrl, "Company – Balance Sheet (FY 2022–23).pdf") },
        { id: 'balancesheet_2024', url: bs2024PreviewUrl || null, name: makeName(bs2024PreviewUrl, "Company – Balance Sheet (FY 2023–24).pdf") },
        // { id: 'bankstat', url: bankStatPreviewUrl || null },
        // { id: 'bankstat_summary', url: bankStatSummaryPreviewUrl || null, name: makeName(bankStatSummaryPreviewUrl, "BankStat_Summary.pdf") },
        { id: 'company_cibil', url: compCibilPreviewUrl || null, name: makeName(compCibilPreviewUrl, "	Company – Credit Report (CIBIL).pdf") },
        { id: 'gst', url: gstPreviewUrl || null, name: makeName(gstPreviewUrl, "Company – GST Registration Certificate.pdf") }, // GST first
        { id: 'profit_loss_2022', url: pl2022PreviewUrl || null, name: makeName(pl2022PreviewUrl, "Company – Profit & Loss Statement (FY 2021–22).pdf") },
        { id: 'profit_loss_2023', url: pl2023PreviewUrl || null, name: makeName(pl2023PreviewUrl, "	Company – Profit & Loss Statement (FY 2022–23).pdf") },
        { id: 'profit_loss_2024', url: pl2024PreviewUrl || null, name: makeName(pl2024PreviewUrl, "Company – Profit & Loss Statement (FY 2023–24).pdf") },
        { id: 'udyam', url: udyamPreviewUrl || null, name: makeName(udyamPreviewUrl, "Company – Udyam Registration Certificate.pdf") }
      ];

      // OPTIMIZED: Use actual uploaded files from Azure Blob instead of API endpoints
      // Get the actual file count from the application info
      let actualUploadedFiles = [];

      // REMOVED: Redundant blob-info API call
      // The file filtering can be done based on PDF URLs returned from the main API calls above
      // No need for a separate blob-info endpoint call

      // Filter to show only documents that have valid PDF URLs
      const availablePages = pages.filter(page => {
        if (!page.url || page.url === null) return false;

        // Check if it's a fallback/default URL (should be excluded)
        if (page.url.includes('APP0A1AKA4M') || page.url.includes('deetsxstorage.blob.core.windows.net/deetsx-applications/APP0A1AKA4M')) {
          console.log(`Excluding fallback URL for ${page.id}: ${page.url}`);
          return false;
        }

        // Show all documents that have valid URLs (not fallback)
        const hasValidUrl = page.url && !page.url.includes('APP0A1AKA4M');
        console.log(`Document ${page.id}: URL=${page.url ? 'exists' : 'null'}, hasValidUrl=${hasValidUrl}`);
        return hasValidUrl;
      });

      console.log(`\n=== PAGINATION DEBUG ===`);
      console.log(`Application Number: ${applicationNumber}`);
      console.log(`Total expected documents: ${pages.length}`);
      console.log(`Available documents after filtering: ${availablePages.length}`);
      console.log('Available documents details:');
      availablePages.forEach((doc, index) => {
        console.log(`  ${index + 1}. ID: ${doc.id}, Name: ${doc.name}, URL: ${doc.url}`);
      });
      console.log(`=========================\n`);

      // If no sections found, keep empty so 'No Data' renders
      setApplicationPdfs(availablePages);
      setCurrentPdfIndex(0);
    } catch (e) {
      console.error('Load failed:', e?.message || e);
      setApplicationPdfs([]);
      setSilverDetails(null);
      setAadhaarPrDetails(null);
      setAadhaarCoDetails(null);
      setPanPrDetails(null);
      setPanCoDetails(null);
      setItrPrDetails(null);
      setItrCoDetails(null);
      setBalanceSheetDetails({ '2022': null, '2023': null, '2024': null });
    } finally {
      setLoading(false);
    }
  };

  // Get PDF URL by ID (unused for Silver streaming, kept for compatibility)
  const getPdfUrl = (pdfId) => `/${pdfId}`;

  // ========================
  // Effects
  // ========================

  useEffect(() => {
    fetchApplications();
  }, [id]);

  // (moved) lazy Aadhaar fetch now lives after currentPageType is declared below

  // ========================
  // Event Handlers
  // ========================

  // Handle application selection change
  const handleApplicationChange = (event, newValue) => {
    setSelectedApplication(newValue);
    if (newValue) {
      fetchApplicationPdfs(newValue);
    } else {
      setApplicationPdfs([]);
    }
  };

  // Handle page navigation
  const handleChangePage = (event, newPage) => {
    if (newPage >= 1 && newPage <= applicationPdfs.length) {
      setCurrentPdfIndex(newPage - 1);
      // Update verification status for the new page
      setIsPageVerified(verifiedPages.has(applicationPdfs[newPage - 1]?.id));
    }
  };

  const handlePrevPage = () => {
    if (currentPdfIndex > 0) {
      const newIndex = currentPdfIndex - 1;
      setCurrentPdfIndex(newIndex);
      // Update verification status for the previous page
      setIsPageVerified(verifiedPages.has(applicationPdfs[newIndex]?.id));
    }
  };

  const handleNextPage = () => {
    if (currentPdfIndex < applicationPdfs.length - 1) {
      const newIndex = currentPdfIndex + 1;
      setCurrentPdfIndex(newIndex);
      // Update verification status for the next page
      setIsPageVerified(verifiedPages.has(applicationPdfs[newIndex]?.id));
    }
  };

  // Get current page number (1-based)
  const currentPage = currentPdfIndex + 1;
  const totalPages = applicationPdfs.length;
  const currentPageType = applicationPdfs[currentPdfIndex]?.id || 'silver';
  useEffect(() => {
    if (!currentPageType) return;

    // Helper function to get correct API endpoint based on page type
    const getUpdateEndpoint = (pageType) => {
      const endpoints = {
        'silver': '/api/silver/loanapplications',
        'aadhaar_pr': '/api/silver/adharapplications',
        'aadhaar_co': '/api/silver/adharapplications',
        'pan_pr': '/api/silver/panapplications',
        'pan_co': '/api/silver/panapplications',
        'itr_pr_2022': '/api/silver/itrapplications',
        'itr_pr': '/api/silver/itrapplications',
        'itr_co_2022': '/api/silver/itrapplications',
        'itr_co_2023': '/api/silver/itrapplications',
        'itr_co': '/api/silver/itrapplications',
        'networth_pr': '/api/silver/networth',
        'networth_co': '/api/silver/networth',
        'cibil_pr': '/api/silver/cibil',
        'cibil_co': '/api/silver/cibil',
        'balancesheet_2022': '/api/silver/balancesheet',
        'balancesheet_2023': '/api/silver/balancesheet',
        'balancesheet_2024': '/api/silver/balancesheet',
        'bankstat': '/api/silver/bankstat',
        'bankstat_summary': '/api/silver/bankstat-summary',
        'company_cibil': '/api/silver/company-cibil',
        'gst': '/api/silver/gst',
        'profit_loss_2022': '/api/silver/profit-loss',
        'profit_loss_2023': '/api/silver/profit-loss',
        'profit_loss_2024': '/api/silver/profit-loss',
        'udyam': '/api/silver/udyam'
      };

      return endpoints[pageType] || '/api/silver/loanapplications';
    };

    // Helper to get query params for the endpoint
    const getQueryParams = (pageType) => {
      const params = {};

      // Add role for role-based documents
      if (pageType.includes('_pr')) params.role = 'PR';
      if (pageType.includes('_co')) params.role = 'CO1';

      // Add year for year-based documents
      if (pageType.includes('_2022')) params.year = '2022';
      if (pageType.includes('_2023')) params.year = '2023';
      if (pageType.includes('_2024')) params.year = '2024';

      return params;
    };

    // Map pageType to documentType and role
    const pageTypeMap = {
      'silver': { docType: 'LOAN_APPLICATION', role: 'MAIN' },
      'aadhaar_pr': { docType: 'AADHAAR', role: 'PR' },
      'aadhaar_co': { docType: 'AADHAAR', role: 'CO1' },
      'pan_pr': { docType: 'PAN', role: 'PR' },
      'pan_co': { docType: 'PAN', role: 'CO1' },
      'itr_pr_2022': { docType: 'ITR', role: 'PR' },
      'itr_pr': { docType: 'ITR', role: 'PR' },
      'itr_co_2022': { docType: 'ITR', role: 'CO1' },
      'itr_co_2023': { docType: 'ITR', role: 'CO1' },
      'itr_co': { docType: 'ITR', role: 'CO1' },
      'networth_pr': { docType: 'NETWORTH', role: 'PR' },
      'networth_co': { docType: 'NETWORTH', role: 'CO1' },
      'cibil_pr': { docType: 'CIBIL', role: 'PR' },
      'cibil_co': { docType: 'CIBIL', role: 'CO1' },
      'balancesheet_2022': { docType: 'BALANCE_SHEET', role: 'MAIN' },
      'balancesheet_2023': { docType: 'BALANCE_SHEET', role: 'MAIN' },
      'balancesheet_2024': { docType: 'BALANCE_SHEET', role: 'MAIN' },
      'bankstat': { docType: 'BANK_STATEMENT', role: 'MAIN' },
      'bankstat_summary': { docType: 'BANK_STATEMENT_SUMMARY', role: 'MAIN' },
      'company_cibil': { docType: 'COMPANY_CIBIL', role: 'MAIN' },
      'gst': { docType: 'GST', role: 'MAIN' },
      'profit_loss_2022': { docType: 'PROFIT_LOSS', role: 'MAIN' },
      'profit_loss_2023': { docType: 'PROFIT_LOSS', role: 'MAIN' },
      'profit_loss_2024': { docType: 'PROFIT_LOSS', role: 'MAIN' },
      'udyam': { docType: 'UDYAM', role: 'MAIN' }
    };

    const mapping = pageTypeMap[currentPageType] || { docType: 'UNKNOWN', role: 'MAIN' };
    setCurrentDocumentType(mapping.docType);
    setCurrentRole(mapping.role);

    console.log(` Page Type: ${currentPageType} → Doc: ${mapping.docType}, Role: ${mapping.role}`);
  }, [currentPageType]);
  const rightPanelData = currentPageType === 'pan_pr'
    ? panPrDetails
    : currentPageType === 'pan_co'
      ? panCoDetails
      : currentPageType === 'aadhaar_pr'
        ? aadhaarPrDetails
        : currentPageType === 'aadhaar_co'
          ? aadhaarCoDetails
          : currentPageType === 'itr_pr_2022'
            ? itrPr2022Details
            : currentPageType === 'itr_pr'
              ? itrPrDetails
              : currentPageType === 'itr_co_2022'
                ? itrCo2022Details
                : currentPageType === 'itr_co_2023'
                  ? itrCo2023Details
                  : currentPageType === 'itr_co'
                    ? itrCoDetails
                    : currentPageType === 'networth_pr'
                      ? netWorthDetails?.pr || null
                      : currentPageType === 'networth_co'
                        ? netWorthDetails?.co || null
                        : currentPageType === 'cibil_pr'
                          ? cibilDetails?.pr || null
                          : currentPageType === 'cibil_co'
                            ? cibilDetails?.co || null
                            : currentPageType === 'balancesheet_2022'
                              ? (balanceSheetDetails && balanceSheetDetails['2022'])
                              : currentPageType === 'balancesheet_2023'
                                ? (balanceSheetDetails && balanceSheetDetails['2023'])
                                : currentPageType === 'balancesheet_2024'
                                  ? (balanceSheetDetails && balanceSheetDetails['2024'])
                                  : currentPageType === 'bankstat'
                                    ? bankStatDetails
                                    : currentPageType === 'bankstat_summary'
                                      ? bankStatSummaryDetails
                                      : currentPageType === 'company_cibil'
                                        ? companyCibilDetails
                                        : currentPageType === 'gst'
                                          ? gstDetails
                                          : currentPageType === 'profit_loss_2022'
                                            ? (profitLossDetails && profitLossDetails['2022']) || null
                                            : currentPageType === 'profit_loss_2023'
                                              ? (profitLossDetails && profitLossDetails['2023']) || null
                                              : currentPageType === 'profit_loss_2024'
                                                ? (profitLossDetails && profitLossDetails['2024']) || null
                                                : currentPageType === 'udyam'
                                                  ? udyamDetails
                                                  : silverDetails;

// Lazy fetch data when navigating to a new page type
useEffect(() => {
  if (!selectedApplication || !currentPageType) return;

  // ✅ FIX: GST aur Company CIBIL ke liye re-fetch band karo
  // Yeh documents single-record hain (no year/role filter needed)
  // fetchApplicationPdfs pe already load ho chuke hain
  // Re-fetch karne se user ke edited values overwrite ho jaate hain
  if (currentPageType === 'gst' || currentPageType === 'company_cibil') {
    console.log(`✅ [PAGE DATA] Skipping re-fetch for ${currentPageType} — already loaded in fetchApplicationPdfs`);
    return;
  }

  const fetchPageData = async () => {
    try {
      console.log(`🔄 [PAGE DATA] Fetching data for ${currentPageType}`);

      // // ✅ GST & Company CIBIL: Skip re-fetch if data already loaded
      // // Re-fetching overwrites locally edited values in ExtractedData formData
      // if (currentPageType === 'gst' && gstDetails) {
      //   console.log('✅ [PAGE DATA] GST already loaded, skipping re-fetch to preserve edits');
      //   return;
      // }
      // if (currentPageType === 'company_cibil' && companyCibilDetails) {
      //   console.log('✅ [PAGE DATA] Company CIBIL already loaded, skipping re-fetch to preserve edits');
      //   return;
      // }

      // Profit & Loss - fetch by year
      if (currentPageType === 'profit_loss_2022') {
        console.log('📊 Fetching Profit & Loss 2022...');
        const r = await getProfitLoss(selectedApplication, { year: '2022' });
        console.log('📊 Received Profit & Loss 2022:', r?.data);
        setProfitLossDetails(prev => ({ ...(prev || {}), '2022': r?.data || null }));
      } else if (currentPageType === 'profit_loss_2023') {
        console.log('📊 Fetching Profit & Loss 2023...');
        const r = await getProfitLoss(selectedApplication, { year: '2023' });
        console.log('📊 Received Profit & Loss 2023:', r?.data);
        setProfitLossDetails(prev => ({ ...(prev || {}), '2023': r?.data || null }));
      } else if (currentPageType === 'profit_loss_2024') {
        console.log('📊 Fetching Profit & Loss 2024...');
        const r = await getProfitLoss(selectedApplication, { year: '2024' });
        console.log('📊 Received Profit & Loss 2024:', r?.data);
        setProfitLossDetails(prev => ({ ...(prev || {}), '2024': r?.data || null }));
      }
      // Balance Sheet - fetch by year
      else if (currentPageType === 'balancesheet_2022') {
        const r = await getBalanceSheet(selectedApplication, { year: '2022' });
        setBalanceSheetDetails(prev => ({ ...(prev || {}), '2022': r?.data || null }));
      } else if (currentPageType === 'balancesheet_2023') {
        const r = await getBalanceSheet(selectedApplication, { year: '2023' });
        setBalanceSheetDetails(prev => ({ ...(prev || {}), '2023': r?.data || null }));
      } else if (currentPageType === 'balancesheet_2024') {
        const r = await getBalanceSheet(selectedApplication, { year: '2024' });
        setBalanceSheetDetails(prev => ({ ...(prev || {}), '2024': r?.data || null }));
      }
      // ITR - fetch by role and year
      else if (currentPageType === 'itr_pr_2022') {
        const r = await getItrApplication(selectedApplication, { role: 'PR', year: '2022' });
        setItrPr2022Details(r?.data || null);
      } else if (currentPageType === 'itr_pr') {
        const r = await getItrApplication(selectedApplication, { role: 'PR', year: '2023' });
        setItrPrDetails(r?.data || null);
      } else if (currentPageType === 'itr_co_2022') {
        const r = await getItrApplication(selectedApplication, { role: 'CO1', year: '2022' });
        setItrCo2022Details(r?.data || null);
      } else if (currentPageType === 'itr_co_2023') {
        const r = await getItrApplication(selectedApplication, { role: 'CO1', year: '2023' });
        setItrCo2023Details(r?.data || null);
      } else if (currentPageType === 'itr_co') {
        const r = await getItrApplication(selectedApplication, { role: 'CO1', year: '2024' });
        setItrCoDetails(r?.data || null);
      }

      console.log(`✅ [PAGE DATA] Data fetched for ${currentPageType}`);
    } catch (error) {
      console.error(`❌ [PAGE DATA] Failed to fetch data for ${currentPageType}:`, error);
    }
  };

  fetchPageData();
}, [currentPageType, selectedApplication]);

  const refreshCurrentSection = async (appId) => {
    try {
      if (currentPageType === 'aadhaar_pr') {
        const r = await getAadhaarApplication(appId, { role: 'PR' });
        setAadhaarPrDetails(r?.data || null);
      } else if (currentPageType === 'aadhaar_co') {
        const r = await getAadhaarApplication(appId, { role: 'CO1' });
        setAadhaarCoDetails(r?.data || null);
      } else if (currentPageType === 'pan_pr') {
        const r = await getPanApplication(appId, { role: 'PR' });
        setPanPrDetails(r?.data || null);
      } else if (currentPageType === 'pan_co') {
        const r = await getPanApplication(appId, { role: 'CO1' });
        setPanCoDetails(r?.data || null);
      } else if (currentPageType === 'itr_pr_2022') {
        const r = await getItrApplication(appId, { role: 'PR', year: '2022' });
        setItrPr2022Details(r?.data || null);
      } else if (currentPageType === 'itr_pr') {
        const r = await getItrApplication(appId, { role: 'PR', year: '2023' });
        setItrPrDetails(r?.data || null);
      } else if (currentPageType === 'itr_co_2022') {
        const r = await getItrApplication(appId, { role: 'CO1', year: '2022' });
        setItrCo2022Details(r?.data || null);
      } else if (currentPageType === 'itr_co_2023') {
        const r = await getItrApplication(appId, { role: 'CO1', year: '2023' });
        setItrCo2023Details(r?.data || null);
      } else if (currentPageType === 'itr_co') {
        const r = await getItrApplication(appId, { role: 'CO1', year: '2024' });
        setItrCoDetails(r?.data || null);
      } else if (currentPageType === 'networth_pr') {
        const r = await getNetWorth(appId, { role: 'PR' });
        setNetWorthDetails(prev => ({ ...(prev || {}), pr: r?.data || null }));
      } else if (currentPageType === 'networth_co') {
        const r = await getNetWorth(appId, { role: 'CO1' });
        setNetWorthDetails(prev => ({ ...(prev || {}), co: r?.data || null }));
      } else if (currentPageType === 'cibil_pr') {
        const r = await getCibil(appId, { role: 'PR' });
        setCibilDetails(prev => ({ ...(prev || {}), pr: r?.data || null }));
      } else if (currentPageType === 'cibil_co') {
        const r = await getCibil(appId, { role: 'CO1' });
        setCibilDetails(prev => ({ ...(prev || {}), co: r?.data || null }));
      } else if (currentPageType === 'balancesheet_2022') {
        const r = await getBalanceSheet(appId, { year: '2022' });
        setBalanceSheetDetails(prev => ({ ...(prev || {}), '2022': r?.data || null }));
      } else if (currentPageType === 'balancesheet_2023') {
        const r = await getBalanceSheet(appId, { year: '2023' });
        setBalanceSheetDetails(prev => ({ ...(prev || {}), '2023': r?.data || null }));
      } else if (currentPageType === 'balancesheet_2024') {
        const r = await getBalanceSheet(appId, { year: '2024' });
        setBalanceSheetDetails(prev => ({ ...(prev || {}), '2024': r?.data || null }));
      } else if (currentPageType === 'bankstat') {
        const r = await getBankStat(appId);
        setBankStatDetails(r?.data || null);
      } else if (currentPageType === 'bankstat_summary') {
        const r = await getBankStatSummary(appId);
        setBankStatSummaryDetails(r?.data || null);
      } else if (currentPageType === 'company_cibil') {
        const r = await getCompanyCibil(appId);
        setCompanyCibilDetails(r?.data || null);
      } else if (currentPageType === 'gst') {
        const r = await getGst(appId);
        setGstDetails(r?.data || null);
      } else if (currentPageType === 'profit_loss_2022') {
        const r = await getProfitLoss(appId, { year: '2022' });
        setProfitLossDetails(prev => ({ ...(prev || {}), '2022': r?.data || null }));
      } else if (currentPageType === 'profit_loss_2023') {
        const r = await getProfitLoss(appId, { year: '2023' });
        setProfitLossDetails(prev => ({ ...(prev || {}), '2023': r?.data || null }));
      } else if (currentPageType === 'profit_loss_2024') {
        const r = await getProfitLoss(appId, { year: '2024' });
        setProfitLossDetails(prev => ({ ...(prev || {}), '2024': r?.data || null }));
      } else if (currentPageType === 'udyam') {
        const r = await getUdyam(appId);
        setUdyamDetails(r?.data || null);
      } else {
        // Fetch both Gold and Silver data for complete information
        const [goldRes, silverRes] = await Promise.all([
          getApplicationDetails(appId).catch(() => ({})),
          getSilverLoanApplication(appId).catch(() => ({}))
        ]);

        const goldData = goldRes?.data || goldRes || {};
        const silverData = silverRes?.data || silverRes || {};
        const silverConfidenceScores = silverRes?.confidenceScores || {};

        // Combine the data - use Silver for loan application fields, Gold for scores/memo
        const combinedData = {
          ...silverData, // Include all silver fields (loan application data)
          ...goldData, // Override with gold data (scores, memo)
          pdfPath: silverData.pdfPath || goldData.pdfPath,
          jsonPath: silverData.jsonPath || goldData.jsonPath,
          scores: goldData.scores || {
            application: { display: 'N/A' },
            financial: { display: 'N/A' },
            bureau: { display: 'N/A' },
            overall: { display: 'N/A' }
          },
          memoNo: goldData.memoNo || 'N/A',
          registrationDate: goldData.registrationDate || 'N/A',
          confidenceScores: silverConfidenceScores // Add confidence scores to combined data
        };

        setSilverDetails(combinedData);
      }
    } catch (e) {
      console.error('Refresh after save failed:', e?.message || e);
    }
  };

  // Generate visible page numbers for pagination
  const getVisiblePages = () => {
    const pages = [];
    const maxVisible = isMobile ? 3 : isTablet ? 4 : 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(totalPages, start + maxVisible - 1);

      if (end - start < maxVisible - 1) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
    }

    return pages;
  };

  // Show popup message
  const showPopup = (message, type = "saved") => {
    setPopupMessage(message);
    setPopupType(type);
    setOpenPopup(true);

    setTimeout(() => {
      setOpenPopup(false);
    }, 3000);
  };

  // Increment verification count for this application and notify Home to refresh
  const incrementVerification = async () => {
    // Check if we have a valid selected application
    if (!selectedApplication || selectedApplication.trim() === '') {
      console.log('No valid application selected, skipping increment');
      return;
    }

    // Check if already verified to prevent duplicate increments
    if (verifiedApplications.has(selectedApplication)) {
      console.log('Application already verified, skipping increment');
      return;
    }

    try {
      console.log('Calling incrementVerification for:', selectedApplication);
      const incRes = await apiIncrementVerification(selectedApplication).catch(() => ({}));
      console.log('Backend response:', incRes);

      // Mark as verified only if backend call succeeds
      if (incRes && incRes.display) {
        setVerifiedApplications(prev => {
          const newSet = new Set([...prev, selectedApplication]);
          // Save to sessionStorage for persistence
          try {
            sessionStorage.setItem('VERIFIED_APPLICATIONS', JSON.stringify([...newSet]));
          } catch (_) { }
          return newSet;
        });
        console.log(`Verification value updated by +1 for application: ${selectedApplication}. New value: ${incRes.display}`);

        // Optimistically patch Home's verification value so UI shows +1 immediately
        try {
          const raw = sessionStorage.getItem('HOME_VER_PATCHES') || '{}';
          const patches = JSON.parse(raw);
          patches[selectedApplication] = incRes.display;
          sessionStorage.setItem('HOME_VER_PATCHES', JSON.stringify(patches));
          // fire a direct event so Home updates the specific row instantly
          try { window.dispatchEvent(new CustomEvent('VER_INCREMENT', { detail: { id: selectedApplication, display: incRes.display } })); } catch (_) { }
        } catch (_) { }

        // Slightly larger delay for blob eventual consistency
        await new Promise((r) => setTimeout(r, 800));

        const ts = Date.now();
        try { localStorage.setItem('HOME_REFRESH', String(ts)); } catch (_) { }
        try { window.dispatchEvent(new Event('focus')); } catch (_) { }
        try { window.dispatchEvent(new Event('HOME_REFRESH_EVENT')); } catch (_) { }
      } else {
        console.log('Backend response missing display field or incRes is null:', incRes);
      }
    } catch (e) {
      console.warn('verification increment failed:', e?.message);
    }
  };

  const handleConfirmAndGoSummary = async () => {
    console.log("🔥 CONFIRM BUTTON CLICKED!");

    // Force-commit any inline edit before confirm (triggers onBlur in inputs)
    console.log("🔄 Forcing blur on active element...");
    try {
      if (document && document.activeElement && typeof document.activeElement.blur === 'function') {
        console.log("📤 Blurring active element:", document.activeElement.tagName, document.activeElement.type);
        document.activeElement.blur();
      }
    } catch (e) {
      console.warn("⚠️ Failed to blur active element:", e);
    }

    // Allow blur->saveField to resolve with more time
    console.log("⏳ Waiting for field saves to complete...");
    await new Promise((r) => setTimeout(r, 500)); // Increased from 150ms to 500ms

  // Slightly larger delay for blob eventual consistency
await new Promise((r) => setTimeout(r, 800));

const ts = Date.now();
try { localStorage.setItem('HOME_REFRESH', String(ts)); } catch (_) { }
try { window.dispatchEvent(new Event('focus')); } catch (_) { }
try { window.dispatchEvent(new Event('HOME_REFRESH_EVENT')); } catch (_) { }

    showPopup("Changes applied successfully!", "applied");

    //  Check if verification is complete (21 or more pages verified)
    try {
      const [verified, total] = verificationCount.split('/').map(Number);
      console.log(`Verification check: ${verified}/${total}`);

      // COMMENTED OUT: Super Admin 21-file logic (will be used later for Super Admin role)
      // Navigate when 21 or more pages are verified
      // if (verified >= 21) {
      //   console.log(" Verification complete (21+ pages)! Navigating to Application Summary...");
      //   // Navigate to Application Summary after 1.5 seconds
      //   setTimeout(() => {
      //     navigate("/applicationsummary", {
      //       state: { applicationNo: selectedApplication }
      //     });
      //   }, 1500);
      // } else {
      //   console.log(` Verification incomplete: ${verified}/${total}. Need at least 21 pages verified.`);
      // }

      // NEW: Tenant Admin actual file count based verification
      console.log(` Tenant Admin verification: ${verified}/${total} files verified`);
      if (verified >= total) {
        console.log(` All files verified (${verified}/${total})! Navigating to Application Summary...`);
        setTimeout(() => {
          navigate("/applicationsummary", {
            state: { applicationNo: selectedApplication }
          });
        }, 1500);
      } else {
        console.log(` Verification incomplete: ${verified}/${total}. Need all ${total} files verified.`);
      }
    } catch (e) {
      console.error(" Error checking verification:", e);
    }
  };




  return (
    <Box
      sx={{
        display: "flex",
        fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif',
        bgcolor: "#fff",
        height: "100vh",
        overflow: { xs: "auto", md: "hidden" },
      }}
    >
      {/* Sidebar */}
      <Sidebar collapsed={collapsed} onToggleSidebar={() => setCollapsed(!collapsed)} onLogout={handleLogout} />

      {/* Main Content with Header */}
      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        <Header collapsed={collapsed} />

        {/* Page Content */}
        <Box sx={{
          p: { xs: 2, sm: 3 },
          pb: 2,
          bgcolor: "#f5f6fa"
        }}>
          {/* Main Header Section */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center", // keep aligned
              justifyContent: "space-between", // instead of space-between
              gap: 2,
              mt: { xs: "2rem", sm: "3rem", md: "3.5rem" },
              mb: 1,
            }}
          >

            {/* Left Column: Application Detail + Verification Status */}
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Box
                sx={{
                  height: "4.25rem",
                  width: "15rem",
                  backgroundColor: "#C7C7C7",
                  borderRadius: "0.625rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 0.125rem 0.375rem rgba(0,0,0,0.08)",
                }}
              >
                <Typography
                  sx={{
                    color: "#034A7F",
                    fontWeight: 600,
                    fontSize: "1rem",
                    textAlign: "center",
                  }}
                >
                  {selectedApplication || "No Application"}
                </Typography>
              </Box>



            </Box>



            {/*  Application Summary Heading + Business Card */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
                alignItems: "flex-end",
              }}
            >
              {/* Application Summary Heading */}
              {/* <Typography
      variant={isMobile ? "h6" : "h5"}
      sx={{
        fontWeight: 600,
        color: "#034A7F",
        fontSize: { xs: "1.25rem", sm: "1.5rem" },
        textAlign: "right",
      }}
    >
      Application Summary
    </Typography> */}
              {/* Business Name Card (StatCards-like) */}
              <Card
                sx={{
                  height: '4.25rem',
                  borderRadius: '0.5rem',
                  boxShadow: 1,
                  transition: 'all .2s ease',
                  '&:hover': { boxShadow: 3 },
                  bgcolor: '#C7C7C7',
                  border: '0.0625rem solid #C7C7C7',
                }}
              >
                <CardContent sx={{ display: 'flex', alignItems: 'center', height: '100%', justifyContent: 'flex-start', p: '0.5rem !important' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.625rem', textAlign: 'left' }}>
                    <Box
                      sx={{
                        width: '2.25rem',
                        height: '2.25rem',
                        borderRadius: '0.5rem',
                        bgcolor: '#034A7F',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {/* Material Icon use karein */}
                      <BusinessIcon sx={{ fontSize: '1.25rem', color: '#5ABA85' }} />

                      {/* Ya phir inme se koi aur icon */}
                      {/* <BusinessCenterIcon sx={{ fontSize: '1.25rem', color: '#034A7F' }} /> */}
                      {/* <StoreIcon sx={{ fontSize: '1.25rem', color: '#034A7F' }} /> */}
                      {/* <ApartmentIcon sx={{ fontSize: '1.25rem', color: '#034A7F' }} /> */}
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                      <Typography sx={{ fontSize: '1rem', color: '#034A7F', lineHeight: 1 }}>Borrower Name</Typography>
                      <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#034A7F', lineHeight: 1.2 }}>{businessName}</Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>

              {/* Constitution Card */}
              {/* <Card
      sx={{
        height: '4.25rem',
        borderRadius: '0.5rem',
        boxShadow: 1,
        transition: 'all .2s ease',
        '&:hover': { boxShadow: 3 },
        bgcolor: '#fff',
        border: '0.0625rem solid #e5e7eb',
      }}
    >
      <CardContent sx={{ display: 'flex', alignItems: 'center', height: '100%', justifyContent: 'flex-start', p: '0.5rem !important' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.625rem', textAlign: 'left' }}>
          <Box
            sx={{
              width: '2.25rem',
              height: '2.25rem',
              borderRadius: '0.5rem',
              bgcolor: '#e8f1fb',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography sx={{ fontSize: '0.875rem', fontWeight: 700, color: '#034A7F' }}>C</Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <Typography sx={{ fontSize: '0.75rem', color: '#034A7F', lineHeight: 1 }}>Constitution</Typography>
            <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#034A7F', lineHeight: 1.2 }}>{constitution}</Typography>
          </Box>
        </Box>
      </CardContent>
    </Card> */}
            </Box>

          </Box>


        </Box>

        {/* Conditional Rendering Based on Application Selection and Data Availability */}
        {(!selectedApplication || loading) ? (
          /* No Application Selected */
          <EmptyState />
        ) : (applicationPdfs.length === 0 && !silverDetails) ? (
          /* No Data Available for Selected Application */
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "calc(100vh - 200px)",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <Box sx={{ textAlign: "center", maxWidth: 400, px: 3 }}>
              {/* Icon or Illustration */}
              <Box
                sx={{
                  width: 120,
                  height: 120,
                  borderRadius: "50%",
                  bgcolor: "#f3f4f6",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 3,
                  border: "3px solid #e5e7eb",
                }}
              >
                <Typography variant="h2" sx={{ color: "#9ca3af", fontSize: "4rem" }}>

                </Typography>
              </Box>

              <Typography
                variant="h4"
                sx={{
                  color: "#374151",
                  mb: 2,
                  fontWeight: 600,
                  fontSize: { xs: "1.5rem", sm: "2rem" }
                }}
              >
                No Data Available
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: "#6b7280",
                  mb: 1,
                  fontSize: "1.1rem",
                  lineHeight: 1.6
                }}
              >
                No documents found for application number:
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  color: "#2e4258",
                  fontWeight: 600,
                  bgcolor: "#f8fafc",
                  px: 2,
                  py: 1,
                  borderRadius: "8px",
                  border: "1px solid #e2e8f0",
                  display: "inline-block"
                }}
              >
                {selectedApplication}
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: "#9ca3af",
                  mt: 3,
                  fontSize: "0.95rem"
                }}
              >
                This application may not exist in the database or no PDFs have been uploaded for this application yet.
              </Typography>
            </Box>
          </Box>
        ) : (
          /* Main Content - Show when application has PDFs */
          <>
            {/* Two Column Layout */}
            <Box
              sx={{
                height: {
                  xs: "calc(100vh - 15rem)",
                  sm: "calc(100vh - 15rem)",
                  md: "calc(100vh - 18rem)"
                },
                minHeight: { xs: "calc(100vh - 15rem)", sm: "calc(100vh - 15rem)", md: "calc(100vh - 18rem)" },
                maxHeight: { xs: "calc(100vh - 15rem)", sm: "calc(100vh - 15rem)", md: "calc(100vh - 18rem)" },
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                px: { xs: "0.75rem", sm: "1rem", md: "1.5rem" },
                gap: { xs: "1rem", sm: "1rem", md: "1.5rem" },
                bgcolor: "#f5f6fa",
                position: "relative",
                mt: "-0.5rem",
                overflow: "hidden",
              }}
            >

              {/* Document Preview Section */}
              <Box sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                height: { xs: "45vh", sm: "45vh", md: "100%" },
                minHeight: { xs: "45vh", sm: "45vh", md: "100%" },
                maxHeight: { xs: "45vh", sm: "45vh", md: "100%" },
                bgcolor: "white",
                borderRadius: "0.75rem",
                overflow: "hidden",
              }}>
                <DocumentPreview
                  currentPage={1}
                  file={applicationPdfs[currentPdfIndex]?.url || null}
                  title={applicationPdfs[currentPdfIndex]?.name || ((applicationPdfs[currentPdfIndex]?.url || '')?.split('?')[0]?.split('/')?.pop() || undefined)}
                  setTotalPages={() => { }}
                  verificationId={rightPanelData?.verificationId || rightPanelData?.verification_id || rightPanelData?.Verification_ID}
                />
              </Box>


              {/* Extracted Data Section */}
              <Box sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                height: { xs: "45vh", sm: "45vh", md: "100%" },
                minHeight: { xs: "45vh", sm: "45vh", md: "100%" },
                maxHeight: { xs: "45vh", sm: "45vh", md: "100%" },
                bgcolor: "white",
                borderRadius: "0.75rem",
                overflow: "hidden",
                position: "relative",
              }}>
                <ExtractedData
                  data={rightPanelData || undefined}
                  confidenceScores={currentPageType === 'silver' ? rightPanelData?.confidenceScores : undefined}
                  saveAdapter={async (appId, payload) => (
                    currentPageType === 'aadhaar_pr'
                      ? updateAadhaarApplication(appId, payload, { role: 'PR' })
                      : currentPageType === 'aadhaar_co'
                        ? updateAadhaarApplication(appId, payload, { role: 'CO1' })
                        : currentPageType === 'pan_pr'
                          ? updatePanApplication(appId, payload, { role: 'PR' })
                          : currentPageType === 'pan_co'
                            ? updatePanApplication(appId, payload, { role: 'CO1' })
                            : currentPageType === 'itr_pr_2022'
                              ? updateItrApplication(appId, payload, { role: 'PR', year: '2022' })
                              : currentPageType === 'itr_pr'
                                ? updateItrApplication(appId, payload, { role: 'PR', year: '2023' })
                                : currentPageType === 'itr_co_2022'
                                  ? updateItrApplication(appId, payload, { role: 'CO1', year: '2022' })
                                  : currentPageType === 'itr_co_2023'
                                    ? updateItrApplication(appId, payload, { role: 'CO1', year: '2023' })
                                    : currentPageType === 'itr_co'
                                      ? updateItrApplication(appId, payload, { role: 'CO1', year: '2024' })
                                      : currentPageType === 'networth_pr'
                                        ? updateNetWorth(appId, payload, { role: 'PR', id: (netWorthDetails && netWorthDetails.pr && netWorthDetails.pr.id) || undefined })
                                        : currentPageType === 'networth_co'
                                          ? updateNetWorth(appId, payload, { role: 'CO1', id: (netWorthDetails && netWorthDetails.co && netWorthDetails.co.id) || undefined })
                                          : currentPageType === 'cibil_pr'
                                            ? updateCibil(appId, payload, { role: 'PR' })
                                            : currentPageType === 'cibil_co'
                                              ? updateCibil(appId, payload, { role: 'CO1' })
                                              : currentPageType === 'balancesheet_2022'
                                                ? updateBalanceSheet(appId, payload, { year: '2022' })
                                                : currentPageType === 'balancesheet_2023'
                                                  ? updateBalanceSheet(appId, payload, { year: '2023' })
                                                  : currentPageType === 'balancesheet_2024'
                                                    ? updateBalanceSheet(appId, payload, { year: '2024' })
                                                    : currentPageType === 'bankstat'
                                                      ? updateBankStat(appId, payload)
                                                      : currentPageType === 'bankstat_summary'
                                                        ? updateBankStatSummary(appId, payload)
                                                        : currentPageType === 'company_cibil'
                                                          ? updateCompanyCibil(appId, payload)
                                                          : currentPageType === 'gst'
                                                            ? updateGst(appId, payload)
                                                            : currentPageType === 'profit_loss_2022'
                                                              ? updateProfitLoss(appId, payload, { year: '2022', id: (profitLossDetails && profitLossDetails['2022'] && profitLossDetails['2022'].id) || undefined })
                                                              : currentPageType === 'profit_loss_2023'
                                                                ? updateProfitLoss(appId, payload, { year: '2023', id: (profitLossDetails && profitLossDetails['2023'] && profitLossDetails['2023'].id) || undefined })
                                                                : currentPageType === 'profit_loss_2024'
                                                                  ? updateProfitLoss(appId, payload, { year: '2024', id: (profitLossDetails && profitLossDetails['2024'] && profitLossDetails['2024'].id) || undefined })
                                                                  : currentPageType === 'udyam'
                                                                    ? updateUdyam(appId, payload)
                                                                    : updateSilverLoanApplication(appId, payload)
                  )}
                  // REMOVED: onSaved prop - no longer needed since we removed automatic refresh after field save
                />
              </Box>
            </Box>

            {/* Bottom Section: Pagination + Buttons */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: { xs: "center", sm: "space-between" },
                alignItems: "center",
                gap: { xs: "0.75rem", sm: "0.5rem" },
                p: { xs: "0.75rem", sm: "1rem" },
                mt: { xs: "0.5rem", sm: "1rem" },
                bgcolor: "#f5f6fa",
                borderTop: "1px solid #e0e0e0",
                flexShrink: 0,
              }}
            >
              {/* Pagination Controls */}
              <Box sx={{
                display: "flex",
                alignItems: "center",
                gap: "0.25rem",
                flexWrap: "wrap",
                justifyContent: { xs: "center", sm: "flex-start" }
              }}>
                {/* First page button */}
                <IconButton
                  size="small"
                  onClick={() => handleChangePage(null, 1)}
                  disabled={currentPage === 1}
                  sx={{
                    minWidth: "1.75rem",
                    width: "1.75rem",
                    height: "1.75rem",
                    border: "1px solid #d0d7de",
                    borderRadius: "4rem",
                    fontSize: "0.75rem",
                    "&:hover": { backgroundColor: "#f6f8fa" },
                    "&:disabled": { opacity: 0.5 },
                  }}
                >
                  <Typography variant="caption">{"<<"}</Typography>
                </IconButton>

                {/* Previous page button */}
                <IconButton
                  size="small"
                  onClick={() => handleChangePage(null, currentPage - 1)}
                  disabled={currentPage === 1}
                  sx={{
                    minWidth: "1.75rem",
                    width: "1.75rem",
                    height: "1.75rem",
                    border: "1px solid #d0d7de",
                    borderRadius: "4rem",
                    fontSize: "0.75rem",
                    "&:hover": { backgroundColor: "#f6f8fa" },
                    "&:disabled": { opacity: 0.5 },
                  }}
                >
                  <Typography variant="caption">{"<"}</Typography>
                </IconButton>

                {/* Page numbers */}
                {getVisiblePages().map((pageNumber) => (
                  <IconButton
                    key={pageNumber}
                    size="small"
                    onClick={() => handleChangePage(null, pageNumber)}
                    sx={{
                      minWidth: "1.75rem",
                      width: "1.75rem",
                      height: "1.75rem",
                      border: "1px solid #d0d7de",
                      borderRadius: "4rem",
                      fontSize: "0.75rem",
                      backgroundColor: currentPage === pageNumber ? "#2e4258" : "transparent",
                      color: currentPage === pageNumber ? "white" : "#24292f",
                      "&:hover": {
                        backgroundColor: currentPage === pageNumber ? "#2e4258" : "#f6f8fa",
                      },
                    }}
                  >
                    <Typography variant="caption" sx={{ fontWeight: 500 }}>
                      {pageNumber}
                    </Typography>
                  </IconButton>
                ))}

                {/* Show ellipsis and last page if needed */}
                {totalPages > 5 && currentPage < totalPages - 2 && (
                  <>
                    <Typography variant="caption" sx={{ px: "0.25rem", color: "#656d76", fontSize: "0.75rem" }}>
                      ...
                    </Typography>
                    <IconButton
                      size="small"
                      onClick={() => handleChangePage(null, totalPages)}
                      sx={{
                        minWidth: "1.75rem",
                        width: "1.75rem",
                        height: "1.75rem",
                        border: "1px solid #d0d7de",
                        borderRadius: "4rem",
                        fontSize: "0.75rem",
                        "&:hover": { backgroundColor: "#f6f8fa" },
                      }}
                    >
                      <Typography variant="caption" sx={{ fontWeight: 500 }}>
                        {totalPages}
                      </Typography>
                    </IconButton>
                  </>
                )}

                {/* Next page button */}
                <IconButton
                  size="small"
                  onClick={() => handleChangePage(null, currentPage + 1)}
                  disabled={currentPage === totalPages}
                  sx={{
                    minWidth: "1.75rem",
                    width: "1.75rem",
                    height: "1.75rem",
                    border: "1px solid #d0d7de",
                    borderRadius: "4rem",
                    fontSize: "0.75rem",
                    "&:hover": { backgroundColor: "#f6f8fa" },
                    "&:disabled": { opacity: 0.5 },
                  }}
                >
                  <Typography variant="caption">{">"}</Typography>
                </IconButton>

                {/* Last page button */}
                <IconButton
                  size="small"
                  onClick={() => handleChangePage(null, totalPages)}
                  disabled={currentPage === totalPages}
                  sx={{
                    minWidth: "1.75rem",
                    width: "1.75rem",
                    height: "1.75rem",
                    border: "1px solid #d0d7de",
                    borderRadius: "4rem",
                    fontSize: "0.75rem",
                    "&:hover": { backgroundColor: "#f6f8fa" },
                    "&:disabled": { opacity: 0.5 },
                  }}
                >
                  <Typography variant="caption">{">>"}</Typography>
                </IconButton>
              </Box>

              {/* Action Buttons */}
              <Box sx={{
                display: "flex",
                gap: "0.5rem",
                order: { xs: 1, sm: 2 },
                width: { xs: "100%", sm: "auto" },
                justifyContent: { xs: "stretch", sm: "flex-end" },
                flexShrink: 0,
              }}>
                {currentPage === 1 ? (
                  <Button
                    variant="contained"
                    sx={{
                      px: { xs: "1rem", sm: "1.25rem" },
                      py: { xs: "0.5rem", sm: "0.5rem" },
                      textTransform: "none",
                      fontSize: { xs: "0.875rem", sm: "0.875rem" },
                      backgroundColor: "#034A7F",
                      flex: { xs: 1, sm: "none" },
                      whiteSpace: "nowrap",
                      "&:hover": { backgroundColor: "#034A7F" },
                    }}
                    onClick={async () => {
                      try {
                        console.log(`🔥 [${currentPageType}] CONFIRM BUTTON CLICKED!`);

                        // 1. Force blur any active input fields to trigger saveField
                        console.log(`🔄 [${currentPageType}] Forcing blur on active elements...`);
                        try {
                          if (document && document.activeElement && typeof document.activeElement.blur === 'function') {
                            console.log(`📤 [${currentPageType}] Blurring active element:`, document.activeElement.tagName, document.activeElement.type);
                            document.activeElement.blur();
                          }
                        } catch (e) {
                          console.warn(`⚠️ [${currentPageType}] Failed to blur active element:`, e);
                        }

                        // 2. Wait for any pending field saves to complete
                        console.log(`⏳ [${currentPageType}] Waiting for field saves to complete...`);
                        await new Promise((r) => setTimeout(r, 500));

                        // 3. Verify page in blob storage
                        console.log(`📄 [${currentPageType}] Verifying page in blob storage...`);
                        await handlePageVerification();

                        // 4. Update Verification_ID in SQL database
                        const endpoint = getUpdateEndpoint(currentPageType);
                        const queryParams = getQueryParams(currentPageType);
                        const queryString = new URLSearchParams(queryParams).toString();
                        const url = `${API_BASE}${endpoint}/${selectedApplication}${queryString ? '?' + queryString : ''}`;

                        console.log(`📤 [${currentPageType}] Updating verification at: ${url}`);
                        console.log(`📦 [${currentPageType}] Request body:`, JSON.stringify({ verifyPage: true }));

                        const response = await fetch(url, {
                          method: 'PUT',
                          headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                          },
                          body: JSON.stringify({ verifyPage: true })
                        });

                        console.log(` Response status: ${response.status}`);

                        if (response.ok) {
                          const result = await response.json();
                          console.log('Verification_ID updated in database:', result);
                        } else {
                          const errorText = await response.text();
                          console.error(' Database update failed:', response.status, errorText);
                        }

                        //  Move to next page
                        handleNextPage();

                        //  Show success popup
                        showPopup("Changes saved successfully!", "saved");

                        //  Check if verification is complete and navigate
                        console.log(" CONFIRM & CONTINUE BUTTON CLICKED!");
                        console.log(" Current verificationCount:", verificationCount);
                        try {
                          const [verified, total] = verificationCount.split('/').map(Number);
                          console.log(` Verification check: ${verified}/${total}`);
                          console.log(` Parsed values - verified: ${verified}, total: ${total}`);

                          // COMMENTED OUT: Super Admin 21-file logic (will be used later for Super Admin role)
                          // Navigate when 21 or more pages are verified
                          // if (verified >= 21) {
                          //   console.log(" Verification complete (21+ pages)! Navigating to Application Summary...");
                          //   setTimeout(() => {
                          //     navigate("/applicationsummary", {
                          //       state: { applicationNo: selectedApplication }
                          //     });
                          //   }, 1500);
                          // } else {
                          //   console.log(` Verification incomplete: ${verified}/${total}. Need at least 21 pages verified.`);
                          // }

                          // NEW: Tenant Admin single-file verification logic
                          // For single-file case: First click = verify, Second click = redirect
                          if (total === 1) {
                            console.log(" Single-file verification detected");
                            if (verified >= 1) {
                              console.log(" Single file already verified (1/1)! Navigating to Application Summary...");

                              // Navigate to Application Summary without changing status
                              setTimeout(() => {
                                navigate("/applicationsummary", {
                                  state: { applicationNo: selectedApplication }
                                });
                              }, 1500);
                            } else {
                              console.log(" Single file not yet verified. First click will verify the file.");
                            }
                          } else {
                            // For multi-file cases, use actual file count based verification
                            console.log(` Multi-file verification: ${verified}/${total} files verified`);
                            console.log(` Checking if ${verified} >= ${total}:`, verified >= total);
                            if (verified >= total) {
                              console.log(` All files verified (${verified}/${total})! Navigating to Application Summary...`);

                              // Navigate to Application Summary without changing status
                              setTimeout(() => {
                                console.log(" Actually navigating now...");
                                navigate("/applicationsummary", {
                                  state: { applicationNo: selectedApplication }
                                });
                              }, 1500);
                            } else {
                              console.log(` Verification incomplete: ${verified}/${total}. Need all files verified.`);
                            }
                          }
                        } catch (e) {
                          console.error(" Error checking verification:", e);
                        }

                      } catch (error) {
                        console.error(' Verification failed:', error);
                        showPopup("Failed to verify page. Please try again.", "error");
                      }
                    }}
                  >
                    Confirm & Continue
                  </Button>
                ) : currentPage < totalPages ? (
                  <>
                    <Button
                      variant="outlined"
                      onClick={handlePrevPage}
                      sx={{
                        px: { xs: "1rem", sm: "1.25rem" },
                        py: { xs: "0.5rem", sm: "0.5rem" },
                        textTransform: "none",
                        fontSize: { xs: "0.875rem", sm: "0.875rem" },
                        borderColor: "#C7C7C7",
                        backgroundColor: "#C7C7C7",
                        color: "#fff",
                        flex: { xs: 1, sm: "none" },
                        whiteSpace: "nowrap",
                        "&:hover": { borderColor: "#C7C7C7", backgroundColor: "#C7C7C7" },
                      }}
                    >
                      Back
                    </Button>
                    <Button
                      variant="contained"
                      sx={{
                        px: { xs: "1rem", sm: "1.25rem" },
                        py: { xs: "0.5rem", sm: "0.5rem" },
                        textTransform: "none",
                        fontSize: { xs: "0.875rem", sm: "0.875rem" },
                        backgroundColor: "#034A7F",
                        flex: { xs: 1, sm: "none" },
                        whiteSpace: "nowrap",
                        "&:hover": { backgroundColor: "#034A7F" },
                      }}
                      onClick={async () => {
                        try {
                          console.log(`🔥 [${currentPageType}] CONFIRM & CONTINUE BUTTON CLICKED!`);

                          // 1. Force blur ALL input/textarea fields to trigger saveField
                          console.log(`🔄 [${currentPageType}] Forcing blur on all input/textarea fields...`);
                          try {
                            // Find all input and textarea elements and blur them
                            const inputs = document.querySelectorAll('input, textarea');
                            console.log(`📤 [${currentPageType}] Found ${inputs.length} input/textarea elements`);
                            inputs.forEach((input, index) => {
                              if (input && typeof input.blur === 'function') {
                                console.log(`📤 [${currentPageType}] Blurring input ${index + 1}:`, input.tagName, input.type, input.name);
                                input.blur();
                              }
                            });
                            console.log(`✅ [${currentPageType}] All inputs blurred`);
                          } catch (e) {
                            console.warn(`⚠️ [${currentPageType}] Failed to blur inputs:`, e);
                          }

                          // 2. Wait for any pending field saves to complete
                          console.log(`⏳ [${currentPageType}] Waiting for field saves to complete...`);
                          await new Promise((r) => setTimeout(r, 1000)); // Increased to 1000ms for reliable database writes

                          // 3. Update Verification_ID in SQL database
                          const endpoint = getUpdateEndpoint(currentPageType);
                          const queryParams = getQueryParams(currentPageType);
                          const queryString = new URLSearchParams(queryParams).toString();
                          const url = `${API_BASE}${endpoint}/${selectedApplication}${queryString ? '?' + queryString : ''}`;

                          console.log(` [${currentPageType}] Updating verification at: ${url}`);

                          const response = await fetch(url, {
                            method: 'PUT',
                            headers: {
                              'Content-Type': 'application/json',
                              'Accept': 'application/json'
                            },
                            body: JSON.stringify({ verifyPage: true })
                          });

                          if (response.ok) {
                            const result = await response.json();
                            console.log(' Verification_ID updated in database:', result);

                            // 4. Verify page in blob storage
                            await handlePageVerification();
                          } else {
                            const errorText = await response.text();
                            console.error(' Database update failed:', response.status, errorText);
                          }

                          // REMOVED: Redundant refresh before moving to next page
                          // Data is already saved, no need to refresh from database
                          // This was causing an unnecessary API call

                          // 5. Move to next page (this will trigger data load for next page)
                          handleNextPage();

                          // Show success popup
                          showPopup("Changes saved successfully!", "saved");

                        } catch (error) {
                          console.error(' Verification failed:', error);
                          showPopup("Failed to verify page. Please try again.", "error");
                        }
                      }}
                    >
                      Confirm & Continue
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      onClick={handlePrevPage}
                      sx={{
                        px: { xs: "1rem", sm: "1.25rem" },
                        py: { xs: "0.5rem", sm: "0.5rem" },
                        textTransform: "none",
                        fontSize: { xs: "0.875rem", sm: "0.875rem" },
                        borderColor: "#C7C7C7",
                        backgroundColor: "#C7C7C7",
                        color: "#fff",
                        flex: { xs: 1, sm: "none" },
                        whiteSpace: "nowrap",
                        "&:hover": { borderColor: "#C7C7C7", backgroundColor: "#C7C7C7" },
                      }}
                    >
                      Back
                    </Button>
                    <Button
                      variant="contained"
                      sx={{
                        px: { xs: "1rem", sm: "1.25rem" },
                        py: { xs: "0.5rem", sm: "0.5rem" },
                        textTransform: "none",
                        fontSize: { xs: "0.875rem", sm: "0.875rem" },
                        backgroundColor: "#034A7F",
                        flex: { xs: 1, sm: "none" },
                        whiteSpace: "nowrap",
                        "&:hover": { backgroundColor: "#034A7F" },
                      }}
                      onClick={async () => {
                        try {
                          console.log(`🔥 [${currentPageType}] FINAL CONFIRM BUTTON CLICKED!`);

                          // 1. Force blur any active input fields to trigger saveField
                          console.log(`🔄 [${currentPageType}] Forcing blur on active elements...`);
                          try {
                            if (document && document.activeElement && typeof document.activeElement.blur === 'function') {
                              console.log(`📤 [${currentPageType}] Blurring active element:`, document.activeElement.tagName, document.activeElement.type);
                              document.activeElement.blur();
                            }
                          } catch (e) {
                            console.warn(`⚠️ [${currentPageType}] Failed to blur active element:`, e);
                          }

                          // 2. Wait for any pending field saves to complete
                          console.log(`⏳ [${currentPageType}] Waiting for field saves to complete...`);
                          await new Promise((r) => setTimeout(r, 500));

                          // 3. Verify page in blob storage
                          console.log(`📄 [${currentPageType}] Verifying page in blob storage...`);
                          await handlePageVerification();

                          // 4. Update Verification_ID in SQL database
                          const endpoint = getUpdateEndpoint(currentPageType);
                          const queryParams = getQueryParams(currentPageType);
                          const queryString = new URLSearchParams(queryParams).toString();
                          const url = `${API_BASE}${endpoint}/${selectedApplication}${queryString ? '?' + queryString : ''}`;

                          console.log(`📤 [${currentPageType}] Updating verification at: ${url}`);
                          console.log(`📦 [${currentPageType}] Request body:`, JSON.stringify({ verifyPage: true }));

                          const response = await fetch(url, {
                            method: 'PUT',
                            headers: {
                              'Content-Type': 'application/json',
                              'Accept': 'application/json'
                            },
                            body: JSON.stringify({ verifyPage: true })
                          });

                          console.log(` Response status: ${response.status}`);

                          if (response.ok) {
                            const result = await response.json();
                            console.log(' Verification_ID updated in database:', result);
                          } else {
                            const errorText = await response.text();
                            console.error(' Database update failed:', response.status, errorText);
                          }

                          //  Move to next page
                          handleNextPage();

                          //  Show success popup
                          showPopup("Changes saved successfully!", "saved");

                          //  Check if verification is complete and navigate
                          console.log(" CONFIRM BUTTON CLICKED!");
                          try {
                            const [verified, total] = verificationCount.split('/').map(Number);
                            console.log(` Verification check: ${verified}/${total}`);

                            // COMMENTED OUT: Super Admin 21-file logic (will be used later for Super Admin role)
                            // Navigate when 21 or more pages are verified
                            // if (verified >= 21) {
                            //   console.log(" Verification complete (21+ pages)! Navigating to Application Summary...");
                            //   setTimeout(() => {
                            //     navigate("/applicationsummary", {
                            //       state: { applicationNo: selectedApplication }
                            //     });
                            //   }, 1500);
                            // } else {
                            //   console.log(` Verification incomplete: ${verified}/${total}. Need at least 21 pages verified.`);
                            // }

                            // NEW: Tenant Admin actual file count based verification
                            console.log(` Tenant Admin verification: ${verified}/${total} files verified`);
                            if (verified >= total) {
                              console.log(` All files verified (${verified}/${total})! Navigating to Application Summary...`);
                              setTimeout(() => {
                                navigate("/applicationsummary", {
                                  state: { applicationNo: selectedApplication }
                                });
                              }, 1500);
                            } else {
                              console.log(` Verification incomplete: ${verified}/${total}. Need all ${total} files verified.`);
                            }
                          } catch (e) {
                            console.error(" Error checking verification:", e);
                          }

                        } catch (error) {
                          console.error(' Verification failed:', error);
                          showPopup("Failed to verify page. Please try again.", "error");
                        }
                      }}
                    >
                      Confirm
                    </Button>
                  </>
                )}
              </Box>

            </Box>
          </>
        )}
      </Box>

      {/* Success/Save Popup Dialog */}
      <Dialog
        open={openPopup}
        onClose={() => setOpenPopup(false)}
        BackdropProps={{
          style: { backgroundColor: "rgba(0,0,0,0.1)" }
        }}
        sx={{
          alignItems: "flex-start",     //  push dialog to top
          justifyContent: "flex-end"    //  push dialog to right

        }}

        PaperProps={{
          sx: {
            borderRadius: "0.75rem",
            p: 0,
            minWidth: { xs: "18.75rem", sm: "23.75rem" },
            maxWidth: "25rem",
            display: "flex",
            alignItems: "stretch",
            gap: 0,
            boxShadow: "0 0.5rem 2rem rgba(0,0,0,0.12)",
            border: "1px solid #e5e7eb",
            position: "fixed",
            top: "0.625rem",
            right: "1.25rem",
            m: 0,
          },
        }}

      >
        <Box sx={{
          display: "flex",
          alignItems: "center",
          gap: "1.5rem",
          p: "1.5rem",
          pr: "2.5rem",
          width: "100%"
        }}>
          <Box
            sx={{
              width: "3rem",
              height: "3rem",
              borderRadius: "0.75rem",
              backgroundColor: popupType === "saved" ? "#FFEA9F" : "#C4F4D0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Box
              component="img"
              src={popupType === "saved" ? ThumbIcon : CheckIcon}
              alt={popupType === "saved" ? "thumb-icon" : "success-icon"}
              sx={{
                width: "2.625rem",
                height: "2.1875rem",
              }}
            />
          </Box>

          <Box sx={{ flex: 1 }}>
            <Typography sx={{
              fontWeight: 700,
              fontSize: "18px",
              color: "#111827",
              lineHeight: 1.3,
              mb: 0.5
            }}>
              {popupMessage}
            </Typography>
            <Typography sx={{
              fontSize: "14px",
              color: "#6b7280",
              lineHeight: 1.4
            }}>
              {popupType === "saved"
                ? "Your work is saved. Keep going!"
                : "Go back to Home page."}
            </Typography>
          </Box>
        </Box>

        <IconButton
          onClick={() => setOpenPopup(false)}
          sx={{
            position: "absolute",
            top: "0.5rem",
            right: "0.5rem",
            width: 32,
            height: 32,
            color: "#9ca3af",
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: "#f3f4f6",
              color: "#6b7280"
            }
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Dialog>
    </Box>
  );
};

export default Application;
